import { FC } from 'react';
import { FiMenu } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';

import LOGOSVG from '../../../assets/icons/logo.svg';
import { Button } from '../../../designComponents';
import { MobileContainer } from './style';
type headerPropsType = {
  open: boolean;
  onClick: () => void;
};
const Header: FC<headerPropsType> = ({ open, onClick }) => {
  return (
    <MobileContainer>
      <div className="menu-bar">
        <img src={LOGOSVG} alt="logo" width={35} height={35} />
        <Button variant="nostyle" onClick={onClick}>
          {open ? (
            <IoClose className="menu-icon" height={35} width={35} />
          ) : (
            <FiMenu className="menu-icon" height={35} width={35} />
          )}
        </Button>
      </div>
    </MobileContainer>
  );
};

export default Header;
